import { animate, state, style, transition, trigger } from '@angular/animations';

export const collapsed = trigger('menuState', [
  state(
    'collapsed',
    style({
      width: '64px',
    }),
  ),
  state(
    'expanded',
    style({
      width: '284px',
    }),
  ),
  transition('collapsed <=> expanded', [animate('300ms ease-in-out')]),
]);
